import request from '@/utils/request'

/**
 * 获取所有填报模板列表（无分页）
 * 适用于需要获取所有模板数据的场景，如下拉选择等
 * @returns {Promise} 返回所有模板列表数据
 */
export function getAllReportTemplates() {
  return request({
    url: '/health-forms/list',
    method: 'get'
  })
}

/**
 * 查询填报模板列表（分页）
 * 适用于表格展示，支持分页查询和关键词搜索
 * @param {Object} query 查询参数
 * @param {string} [query.keyword] 搜索关键词，模糊匹配模板名称
 * @param {number} query.pageNum 当前页码
 * @param {number} query.pageSize 每页数量
 * @returns {Promise} 返回分页模板列表数据
 */
export function searchReportTemplates(query) {
  return request({
    url: '/health-forms/search',
    method: 'post',
    data: query
  })
}

/**
 * 根据ID获取填报模板详情
 * 用于获取单个模板的完整信息，包括模板基本信息、排查状况字段和管控措施字段
 * @param {string} id 模板ID
 * @returns {Promise} 返回单个模板的详细数据
 */
export function getReportTemplateById(id) {
  return request({
    url: `/health-forms/${id}`,
    method: 'get'
  })
}

/**
 * 创建新的填报模板
 * @param {Object} data 模板数据
 * @param {string} data.name 模板名称
 * @param {number} data.healthRatingId 健康评级ID
 * @param {Array<number>} data.classIds 适用班组ID数组
 * @param {number} data.fillType 填报类型：1按天 2按班组
 * @param {number} data.status 状态：1启用 2禁用
 * @param {Array<Object>} data.fields 表单字段数组
 * @param {Array<Object>} data.measures 管控措施数组
 * @returns {Promise} 返回创建结果
 */
export function createReportTemplate(data) {
  return request({
    url: '/health-forms',
    method: 'post',
    data
  })
}

/**
 * 更新填报模板
 * @param {string} id 模板ID
 * @param {Object} data 模板数据，结构同createReportTemplate
 * @returns {Promise} 返回更新结果
 */
export function updateReportTemplate(id, data) {
  return request({
    url: `/health-forms/${id}`,
    method: 'put',
    data
  })
}

/**
 * 删除填报模板
 * @param {string} id 模板ID
 * @returns {Promise} 返回删除结果
 */
export function deleteReportTemplate(id) {
  return request({
    url: `/health-forms/${id}`,
    method: 'delete'
  })
}

/**
 * 修改填报模板状态（启用/禁用）
 * @param {string} id 模板ID
 * @param {number} status 状态值（1启用 2禁用）
 * @returns {Promise} 返回状态修改结果
 */
export function updateReportTemplateStatus(id, status) {
  return request({
    url: `/health-forms/${id}/status`,
    method: 'post',
    data: { status }
  })
} 